import Header from 'components/Header'
import Menu from 'components/Menu'
import Footer from 'components/Footer'
import { useOneTrust } from 'hooks/useOneTrust'

const PRIVACY_POLICY_OT_ID_TERMS_OF_USE = '448fe9bf-cd3e-453d-b712-196a6c3e0caa'
const TermsOfUseEleven = () => {
  useOneTrust(PRIVACY_POLICY_OT_ID_TERMS_OF_USE)

  return (
    <div>
      <Header />
      <Menu />

      <div
        id={`otnotice-${PRIVACY_POLICY_OT_ID_TERMS_OF_USE}`}
        className="otnotice privacy-police container"
      />

      <Footer />
    </div>
  )
}
export default TermsOfUseEleven
